// Modules
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
// Material-UI
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
// Types
import type { AlertDialogAction } from "./AlertDialog/types";
import { formatDate, formatTime } from "@/helpers/dates";

type AlertDialogProps = {
    open: boolean;
    title?: string;
    actions: {
        primary: AlertDialogAction | undefined;
        secondary: {
            action: () => void;
            label: string;
        };
    };
    confirmation?: string;
    confirmationValue?: string;
    description?: string;
    value?: number;
    dates?: string[];
    handleClose: () => void;
};

export default function AlertDialog({
    open,
    title,
    actions,
    confirmation,
    confirmationValue,
    description,
    value,
    dates,
    handleClose
}: AlertDialogProps) {
    const language = useSelector((state: any) => state.customization.locale);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs">
            {title && (
                <DialogTitle id="dialog-alert-title">
                    <FormattedMessage id={title} values={value ? { amount: value } : undefined} />
                </DialogTitle>
            )}

            {description && (
                <DialogContent>
                    <DialogContentText id="dialog-alert--description">{description}</DialogContentText>
                </DialogContent>
            )}
            {confirmation && (
                <DialogTitle id="dialog-alert--description">
                    <DialogContentText id="dialog-alert--description">
                        <FormattedMessage id={confirmation} values={{ value: <b>{confirmationValue}</b> }} />
                    </DialogContentText>
                </DialogTitle>
            )}
            {dates && dates.length > 0 && (
                <DialogContent>
                    {dates.map((date, index) => (
                        <DialogContentText key={index} sx={{ mt: 1 }}>
                            {`${formatDate(date, { weekday: "long", month: "long" }, language)} `}
                            <FormattedMessage id="around" />
                            {` ${formatTime(date, { minute: undefined }, language)}`}
                        </DialogContentText>
                    ))}
                </DialogContent>
            )}
            <DialogActions sx={{ mr: 2 }}>
                <Button onClick={actions?.secondary?.action} color="error">
                    <FormattedMessage id={actions?.secondary?.label} />
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    onClick={actions?.primary?.action}
                    autoFocus
                    data-testid={`confirm-${actions?.primary?.label}-event`}
                >
                    <FormattedMessage id={actions?.primary?.label} />
                </Button>
            </DialogActions>
        </Dialog>
    );
}
